import cn from "classnames";
import { mapThemeFromUi, MapThemeUi, MapThemeUiValue, mapUiFromTheme } from "../model/types";
import { useAppDispatch, useAppSelector } from "shared/lib/redux";
import { useTranslation } from "shared/localization/localization";
import { Button } from "shared/ui/Button";
import { MoonIcon, SunIcon } from "shared/ui/Icons/Icons";
import styles from "./ThemeSwitcher.module.scss";

import { mapThemeStore } from "../model/mapTheme.store";

type ThemeSwitcherProps = {
  className?: string;
};

export const ThemeSwitcher: RFC<ThemeSwitcherProps> = ({ className }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const mapStyle = useAppSelector(mapThemeStore.selectors.style);
  const activeUi = mapUiFromTheme(mapStyle);

  const handleSelect = (ui: MapThemeUiValue) => {
    dispatch(mapThemeStore.actions.setMapTheme(mapThemeFromUi(ui)));
  };

  return (
    <div className={cn(styles.switcher, className)} role="group" aria-label={t("Map theme")}>
      <Button
        type="button"
        size="tiny"
        className={cn(styles.option, { [styles.active]: activeUi === MapThemeUi.LIGHT })}
        onClick={() => handleSelect(MapThemeUi.LIGHT)}
        aria-pressed={activeUi === MapThemeUi.LIGHT}
      >
        <SunIcon />
      </Button>
      <span className={styles.divider} aria-hidden />
      <Button
        type="button"
        size="tiny"
        className={cn(styles.option, { [styles.active]: activeUi === MapThemeUi.DARK })}
        onClick={() => handleSelect(MapThemeUi.DARK)}
        aria-pressed={activeUi === MapThemeUi.DARK}
      >
        <MoonIcon />
      </Button>
    </div>
  );
};
